<template>
	<div class="titKind">
		<ul>
			<li :class="item.selected?'on':''" v-for="(item,index) in kindlst" :key="item.index">
				<a href="#" @click="tabItem(index)">{{item.name}}</a>
			</li>
		</ul>
	</div>
</template>
<script>
	export default {
		name: 'titKind',
		props: {
			kindlst: Array
		},
		components: {

		},
		data() {
			return {
				current: 0
			}
		},
		methods: {
			tabItem(index) {
				this.current = index;
				this.$parent.getList(index)
			}
		}
	}
</script>

<style scoped lang="scss">
	.titKind {
		height: 70px;
		ul {
			li {
				display: inline-block;
				*display: inline;
				zoom: 1;
				&:not(:last-child) {
					margin-right: 70px;
				}
				a {
					display: block;
					font-size: 18px;
					color: #000;
					height: 32px;
					line-height: 32px;
				}
				&.on {
					a{
						color: #1e90ff;
				  	border-bottom: 2px solid #1e90ff;
					}
				}
			}
		}
	}
</style>